import { pathOr } from 'ramda'

import { ERROR_CODES, TECHNICAL_ERROR_LABELS } from 'App/constants'

const getErrorData = (error): any => {
  const isNetworkError = error.response
  const status = pathOr(null, ['response', 'status'])(error)
  const {
    code,
    target = '',
    message: messageFromResponse,
    details,
    errorType,
  }: any = pathOr({}, ['response', 'data', 0])(error)

  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  const isClientError = status < 500 && status >= 400
  const isTechnicalError = !isNetworkError || !isClientError

  return {
    status,
    errorType,
    code: code || error.code || ERROR_CODES.technicalError,
    details,
    message: messageFromResponse || error.message || TECHNICAL_ERROR_LABELS.general,
    target: target || error.target,
    isClientError,
    isTechnicalError,
  }
}

export default getErrorData
